import React, { createContext } from 'react'

type ContractEditContext = {
  user: React.ReactNode
  setUser: React.Dispatch<React.SetStateAction<undefined>>
  items: React.ReactNode
  setItems: React.Dispatch<React.SetStateAction<any[]>>
  signedItems: React.ReactNode
  setSignedItems: React.Dispatch<React.SetStateAction<never[]>>
  fieldsCounter: string | never[]
  setFieldsCounter: React.Dispatch<React.SetStateAction<never[]>>
  fileMetadata: Record<string, any>
  setFileMetadata: React.Dispatch<React.SetStateAction<never[]>>
  contract: Record<string, any>
  bottomNavSelectedItem: Record<string, any>
  selectedShape: React.ReactNode
  selectShape: React.Dispatch<React.SetStateAction<null>>
}

export default createContext<ContractEditContext>({} as ContractEditContext)
